import { useState } from "react";
import { Link } from "react-router-dom";

const MovieCard = ({
  id,
  poster,
  disabledLink = true,
  redirectLink = null,
  description,
  onClick = () => { },
}) => {
  const redirectHref = redirectLink || `/reviews/${id}`;
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="movie-card-frame">
      {!imageLoaded && <div className="poster-skeleton" />}

      <div className={`movie-card-content ${imageLoaded ? "show" : "hide"}`}>
        {!disabledLink ? (
          <Link to={redirectHref}>
            <img
              src={poster}
              alt=""
              className="movie-card-poster"
              onLoad={() => setImageLoaded(true)}
              onClick={onClick}
            />
          </Link>
        ) : (
          <img
            src={poster}
            alt=""
            className="movie-card-poster"
            onLoad={() => setImageLoaded(true)}
            onClick={onClick}
          />
        )}

        {description && <p className="movie-card-description">{description}</p>}
      </div>
    </div>
  );
};

export default MovieCard;
